import { render, staticRenderFns } from "./generalInformation.vue?vue&type=template&id=16c3d500&scoped=true"
import script from "./generalInformation.vue?vue&type=script&lang=js"
export * from "./generalInformation.vue?vue&type=script&lang=js"
import style0 from "./generalInformation.vue?vue&type=style&index=0&id=16c3d500&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c3d500",
  null
  
)

export default component.exports